module.exports = __webpack_public_path__ + "media/images/pages/careers-support/computer_science_careers-702d4cdc09444d2297e20ff7102910a6.jpeg";